import format from 'date-fns/format';

import { IAppointments } from 'pages/Agenda/interfaces';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { parseServiceName } from 'utils/parseServiceName';
import { HistoricDetailsModal } from '../HistoricDetailsModal/HistoricDetailsModal';
import { Container } from './_nextAppointmentPanel';

interface INextAppointmentPanelProps {
  appointment: IAppointments;
}

export const NextAppointmentPanel = ({
  appointment,
}: INextAppointmentPanelProps) => {
  const [showHistoricDetailsModal, setShowHistoricDetailsModal] = useState(false);
  const history = useHistory();

  const handleShowHistoricDetailsModal = () => {
    setShowHistoricDetailsModal(true);
  };

  const handleGoToAgenda = () => {
    history.push('/agenda')
  }

  return (
    <Container>
      <h4 className="next-appointment-panel__title">Próximo agendamento</h4>
      <p className="next-appointment-panel__text">
        {parseServiceName(appointment?.service_type?.name || '')} -{' '}
        {appointment?.user?.individual_person?.name.split(' ')[0]}
      </p>
      <p>
        Solicitação agendada:{' '}
        <time className="next-appointment-panel__time">
          {
            format(new Date(appointment.service_solicitation.date), "dd/MM/yyyy 'às' HH:mm'h'")
          }
        </time>
      </p>
      <button type="button" className="next-appointment-panel__details-button" onClick={handleGoToAgenda}>
        Ver detalhes
      </button>
      {
        showHistoricDetailsModal && (
          <HistoricDetailsModal
            code={Number(appointment?.code)}
            toggleModal={setShowHistoricDetailsModal}
          />
        )
      }
    </Container>
  );
};
